import './ProductListContainer.scss';
import Component from './ProductListContainer.js';
export default Component;
